<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <project-title />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <project-summary />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <project-url />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <project-status />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <project-param-groups />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import ProjectUrl from '@/views/Admin/Projects/Elements/Url.vue'
import ProjectTitle from '@/views/Admin/Projects/Elements/Title.vue'
import ProjectSummary from '@/views/Admin/Projects/Elements/Summary.vue'
import ProjectParamGroups from '@/views/Admin/Projects/Elements/ParamGroups.vue'
import ProjectStatus from '@/views/Admin/Projects/Elements/Status.vue'

export default {
  name: 'ProjectsItemForm',
  components: {
    ProjectStatus,
    ProjectParamGroups,
    ProjectSummary,
    ProjectTitle,
    ProjectUrl,
    BCard,
    BRow,
    BCol,
  },
}
</script>
